<div class="mt-4">
  <button class="btn btn-primary mb-3" data-bs-toggle="modal" data-bs-target="#faqModal" (click)="resetForm()">
    <i class="fas fa-plus"></i> Add FAQ
  </button>

  <div class="table-responsive">
    <table class="table table-striped align-middle  dashboard-table">
      <thead>
        <tr>
          <th>Question</th>
          <th>Answer</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let faq of faqs">
          <td>{{ faq.question }}</td>
          <td>{{ faq.answer }}</td>
          <td>
            <button class="btn btn-warning btn-sm me-2 mt-1" (click)="editFaq(faq)">
              <i class="fas fa-edit"></i>
            </button>
            <button class="btn btn-danger btn-sm mt-1" (click)="deleteFaq(faq.id!)">
              <i class="fas fa-trash"></i>
            </button>
          </td>
        </tr>
        <tr *ngIf="faqs.length === 0 && showSpinner==false" style="text-align: center;">
          <td colspan="3" class="text-muted">No FAQs available</td>
        </tr>
          <tr *ngIf="showSpinner" style="text-align: center;">
          <td colspan="5" >
            <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<!-- Add/Edit FAQ Modal -->
<div class="modal fade" id="faqModal" tabindex="-1" aria-labelledby="faqModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <form #faqForm="ngForm" (ngSubmit)="saveFaq(faqForm)">
        <div class="modal-header">
          <h5 class="modal-title" id="faqModalLabel">{{ editMode ? 'Edit FAQ' : 'Add FAQ' }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>

        <div class="modal-body">
          <div class="mb-3">
            <label>Question <span class="text-danger">*</span></label>
            <input type="text" class="form-control" name="question" [(ngModel)]="currentFaq.question" #question="ngModel" required minlength="3">
            <div *ngIf="question.invalid && question.touched" class="text-danger small">
              <div *ngIf="question.errors?.['required']">Question is required</div>
              <div *ngIf="question.errors?.['minlength']">Question must be at least 3 characters</div>
            </div>
          </div>

          <div class="mb-3">
            <label>Answer <span class="text-danger">*</span></label>
            <textarea class="form-control" name="answer" [(ngModel)]="currentFaq.answer" #answer="ngModel" required minlength="5"></textarea>
            <div *ngIf="answer.invalid && answer.touched" class="text-danger small">
              <div *ngIf="answer.errors?.['required']">Answer is required</div>
              <div *ngIf="answer.errors?.['minlength']">Answer must be at least 5 characters</div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
          <button type="submit" class="btn btn-success" data-bs-dismiss="modal" [disabled]="faqForm.invalid">
            <i class="fas fa-save"></i> {{ editMode ? 'Update' : 'Save' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
